<script>
    import errorList2 from "shared/Components/errorList2.vue";

    export default {
        props: {
            label: String,
            half: Boolean,
            inlineErrors: {
                type: Boolean,
                default: process.env.INLINE_ERRORS
            }
        },
        data() {
            return {
                fieldName: null,
                validationScope: null
            };
        },
        mounted() {
            let nameEl = this.$el.querySelector("[name]");
            if(nameEl) {
                this.fieldName = nameEl.getAttribute("name");

                let scopeEl = this.$el.querySelector("[data-vv-scope]");
                if(scopeEl) {
                    this.validationScope = scopeEl.getAttribute("data-vv-scope");
                }
            }
        },
        computed: {
            fieldErrors() {
                return this.errors.items.filter(x => x.field === this.fieldName);
            },
            field() {
                if(this.validationScope) {
                    return this.fields["$" + this.validationScope][this.fieldName];
                }
                return this.fields[this.fieldName];
            },
            isValid() {
                if(this.field && this.field.validated) {
                    return this.field.valid;
                }
                return true;
            },
            isRequired() {
                if(this.field) {
                    return this.field.required;
                }
                return false;
            }
        },
        components: {
            errorList2
        },
        inject: ['$validator']
    }
</script>

<template>
    <div class="slider-field" :class="{ 'input-half': half }" :aria-required="isRequired" :aria-invalid="!isValid">
        <label>
            <span class="slider-label" v-if="label" :class="{'slider-label-error-state': fieldErrors.length}">{{label}}</span>
            <span :class="{'slider-label-error-state': fieldErrors.length}">
                <slot name="label"></slot>
            </span>
            <slot></slot>
        </label>
        <error-list2 v-if="inlineErrors" :aria-only="false" :messages="fieldErrors" class="inline-errors" prefix=""></error-list2>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .slider-label-error-state {
        color: @ibe-text--red;
    }
</style>
